import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=6fcf2ad4&scoped=true&"
import script from "./login-card.vue?vue&type=script&lang=js&"
export * from "./login-card.vue?vue&type=script&lang=js&"
import style0 from "./login-card.vue?vue&type=style&index=0&id=6fcf2ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf2ad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VForm,VImg,VSimpleCheckbox,VTextField})
